import * as React from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./button";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  ActionIcon?: LucideIcon;
  variant?: 'default' | 'primary' | 'muted';
  compact?: boolean;
  className?: string;
}

const iconColorClasses = {
  default: 'text-slate-400',
  primary: 'text-primary',
  muted: 'text-muted-foreground',
};

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  ActionIcon,
  variant = 'default',
  compact = false,
  className,
}: EmptyStateProps) {
  const iconSize = compact ? 32 : 48;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        compact ? 'py-8 px-4' : 'py-12 px-6',
        className
      )}
    >
      <div className={cn('mb-4', iconColorClasses[variant])}>
        <Icon size={iconSize} className="opacity-60" />
      </div>
      
      <h3
        className={cn(
          'font-semibold text-slate-700 mb-2 text-center',
          compact ? 'text-base' : 'text-lg'
        )}
      >
        {title}
      </h3>
      
      {description && (
        <p
          className={cn(
            'text-slate-500 text-center mb-6',
            compact ? 'text-xs max-w-xs' : 'text-sm max-w-sm'
          )}
        >
          {description}
        </p>
      )}
      
      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          variant="default"
          size={compact ? 'sm' : 'default'}
          className="gap-2"
        >
          {ActionIcon && <ActionIcon size={compact ? 14 : 16} />}
          {actionLabel}
        </Button>
      )}
    </div>
  );
}



